
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/services/test-equipment-modernization",
      function () {
        return require("private-next-pages/[locale]/services/test-equipment-modernization.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/services/test-equipment-modernization"])
      });
    }
  